// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-rise -> price-brothers-rise -> sheridan-ridge-townhomes
// Generated: 2026-11-03T22:58:20.466Z
// Counts: 1 design, 74 content, 6 slot group, 2 collection binding, 7 section, 2 style

export const designOverrides = {
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  }
};

export const contentOverrides = {
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Frequently Asked Questions</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "json-ld-schema.override_phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "propertyoverview.description": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_short_description"
  },
  "rentcafe-chatbot.background_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_secondary_color"
  },
  "tabbedcallouts.panel1_body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_gallery_blurb"
  },
  "tabbedcallouts.panel2_body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_amenities_blurb"
  },
  "tabbedcallouts.panel3_body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_neighborhood_blurb"
  },
  "_head.favicon_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_company_icon"
  },
  "2-bedrooms-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>2-Bedroom Apartments in&nbsp;<span data-type=\"field-token\" data-field=\"property_address_city\"></span>,&nbsp;<span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "2-bedrooms-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>2 Bedrooms</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibility-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Our commitment to accessible living at&nbsp;<span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Accessibility</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Discover the community features and resident amenities at&nbsp;<span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Apartment Features</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Community Amenities</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Start your application for <span data-type=\"field-token\" data-field=\"property_name\"></span> in&nbsp;<span data-type=\"field-token\" data-field=\"property_address_city\"></span>,&nbsp;<span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apply Now</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_secondary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reach out to the team at&nbsp;<span data-type=\"field-token\" data-field=\"property_name\"></span> — we're here to help</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Contact Us</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featured-floor-plan-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>A Closer Look At Our Showcase Layout at <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "featured-floor-plan-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Featured Floor Plan</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span>-Bedroom Apartments in&nbsp;<span data-type=\"field-token\" data-field=\"property_address_city\"></span>,&nbsp;<span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Floor Plans</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>View photos of apartments and community spaces at&nbsp;<span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Gallery</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Apartments in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2><span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "_template:hyperlocal::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Discover modern living at Eastpark with in-unit laundry. Enjoy ultimate convenience in Denton, TX, where comfort meets stylish amenities.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/poolside-cabanas-garland-tx-apartments::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Discover apartments with poolside cabanas in Garland, TX. Luxury living with resort-style amenities is waiting for you.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/in-unit-laundry-apartments-denton-tx::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apartments with In-Unit Laundry in Denton, TX</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/poolside-cabanas-garland-tx-apartments::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Poolside Cabanas in Garland TX Apartments</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apartment Site Map in&nbsp;<span data-type=\"field-token\" data-field=\"property_address_city\"></span>,&nbsp;<span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Interactive Map</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Explore what's near <span data-type=\"field-token\" data-field=\"property_name\"></span> in&nbsp;<span data-type=\"field-token\" data-field=\"property_address_city\"></span>,&nbsp;<span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Neighborhood</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pep-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Exclusive Perks For Local Employees</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "pep-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Preferred Employer Program</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pep-intro.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Price Brothers Management Co. is proud to offer a Preferred Employer Program at <span data-type=\"field-token\" data-field=\"property_name\"></span>! Team members of participating companies receive waived application and administrative fees, making it even easier to call our community home. Have questions or want to see if you qualify? Contact our team—we’re here to help!</p><p>Program details and eligibility are subject to change at any time. Applicants must provide valid proof of employment with an approved Preferred Employer and meet all standard application requirements.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pepbenefits.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Exclusive Perks for Preferred Employers</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pepbenefits.intro": {
    "overrideType": "VALUE",
    "customValue": "<p>Price Brothers Management Co. is proud to offer a Preferred Employer Program at <span data-type=\"field-token\" data-field=\"property_name\"></span>! Team members of participating companies receive waived application and administrative fees, making it even easier to call our community home. Have questions or want to see if you qualify? Contact our team—we’re here to help!</p><p>Program details and eligibility are subject to change at any time. Applicants must provide valid proof of employment with an approved Preferred Employer and meet all standard application requirements.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pepcalltoaction.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Take the next step toward calling <span data-type=\"field-token\" data-field=\"property_name\"></span> home — apply today and enjoy the benefits of our exclusive discount program!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pepcalltoaction.eyebrow": {
    "overrideType": "VALUE",
    "customValue": "<p>Ready to Claim Your Benefits?</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pepcalltoaction.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Ready to Redeem This Offer?</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pepemployers.footnote": {
    "overrideType": "VALUE",
    "customValue": "<p><em>Program details and eligibility are subject to change at any time. Applicants must provide valid proof of employment with an approved Preferred Employer and meet all standard application requirements.</em></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pepemployers.heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Preferred Employer Partners</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "pepemployers.list": {
    "overrideType": "VALUE",
    "customValue": "<ul><li><p>Local Hospital &amp; Medical Center</p></li><li><p>Regional School District</p></li><li><p>City Fire &amp; Police Departments</p></li><li><p>Municipal Government Employees</p></li><li><p>State University Faculty &amp; Staff</p></li><li><p>Federal &amp; Military Personnel</p></li><li><p>Community College &amp; Trade Schools</p></li><li><p>Nonprofit &amp; Faith-Based Organizations</p></li></ul>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Learn about pet-friendly living at&nbsp;<span data-type=\"field-token\" data-field=\"property_name\"></span> in&nbsp;<span data-type=\"field-token\" data-field=\"property_address_city\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Pet Policy</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions": {
    "overrideType": "VALUE",
    "customValue": "<p>Restrictions: Aggressive dog breeds including, but not limited to, Pit Bull, American Staffordshire Terrier, Rottweiler, German Shepherd, Malamute, Doberman Pinscher, Chow, Great Dane, Saint Bernard, Akita, Wolf Hybrid, and any mixed breed that includes the aforementioned, are specifically prohibited and Landlord has discretion to limit other breeds. Inherently dangerous or exotic, feral or wild animals are prohibited.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience <span data-type=\"field-token\" data-field=\"property_name\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Review how <span data-type=\"field-token\" data-field=\"property_name\"></span> protects your personal information</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Privacy Policy</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Access your resident portal and community resources at&nbsp;<span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Resident Access</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>See what residents say about life at&nbsp;<span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Reviews</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule a personal tour of <span data-type=\"field-token\" data-field=\"property_name\"></span> in&nbsp;<span data-type=\"field-token\" data-field=\"property_address_city\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Schedule A Tour</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "sister-properties-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Each Price Brothers Management Co. community has its own character, amenities, and floor plans. Explore the options above to find the one that feels like home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "sister-properties-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Nearby Communities From Price Brothers Management Co.</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sister-properties-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore More Places to Call Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Navigate all pages on the <span data-type=\"field-token\" data-field=\"property_name\"></span> website</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Sitemap</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "tabbedcallouts.panel1_heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Designed For Modern Luxury</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "tabbedcallouts.panel2_heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Resort-Style Living, Every Day</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "tabbedcallouts.panel3_heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Explore The Neighborhood</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>We appreciate your interest in&nbsp;<span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Thank You</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Apartment Tours in&nbsp;<span data-type=\"field-token\" data-field=\"property_address_city\"></span>,&nbsp;<span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Virtual Tours</h2>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "floorplanslist.card_image_0": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "floorplanslist.card_image_2": {
    "sourceIndex": 11,
    "fieldOverrides": null
  },
  "hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a0b65e-e13f-75ac-8873-72d75f98aa62.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor swimming pool with lounge chairs and apartment buildings in the background."
      }
    }
  },
  "pinnedcallouts.bg_image": {
    "sourceIndex": 5,
    "fieldOverrides": null
  },
  "tabbedcallouts.panel1_image": {
    "sourceIndex": 14,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {
  "galleryapartments.images": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": [
      "ec_f2147c0c7008dfd643e31bd9",
      "ec_5bed033fa1fb7b293fa3d70e",
      "ec_071d47b4aec1b54c93c58fe9",
      "ec_4f383c31921dd4eced1de48e",
      "ec_9897294d911d045579485c8c",
      "ec_abb9bfc6dafc464669063fc9",
      "ec_4051e1376f34a5bf439e895e",
      "ec_bb1dd7d0999fec96d55dfa05",
      "ec_f90e584d40d90b1d59309bc5",
      "ec_242c1ea184ea96d525583562",
      "ec_231e5f99c896e9dca1954327",
      "ec_8064dc68927ca4bad1a6abb1",
      "ec_c196ed7569287dc071b53783",
      "ec_221a76b72ae8b3164727324b"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "gallerycommunity.images": {
    "limit": null,
    "hiddenIds": [
      "ec_eb2dd06837e4c639cf08d983"
    ],
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    }
  ],
  "interactive-map": [
    {
      "sectionId": "apartment-sync-map",
      "blockId": "apartment-sync-map",
      "position": 8
    }
  ]
};

export const styleOverrides = {
  "_section.block:apartment-sync-map": {
    "properties": {
      "paddingTop": "15px",
      "paddingRight": "15px",
      "paddingBottom": "15px",
      "paddingLeft": "15px",
      "backgroundColor": "#ffffff"
    }
  },
  "propertyoverview.pre_title": {
    "properties": {
      "fontWeight": "600"
    }
  }
};
